<span [innerHTML]="inputData" #scrollHere ></span>